import React from "react";
import { EnumUserAcces, MenuItem } from "../Managers/dataStructures";
import { getIsMenuAltered, getUserAccess } from "../Managers/profileManager";

interface SidebarDesktopProps {
  menuSelectionHandler: (selectionItem: MenuItem) => void;
  array_menuItems: MenuItem[];
}

const sidebarProp: string =
  getIsMenuAltered() === true
    ? "hidden xxl:fixed xxl:inset-y-0 xxl:z-50 xxl:flex xxl:w-72 xxl:flex-col"
    : "hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col";

export default function SidebarDesktop(props: SidebarDesktopProps) {
  return (
    <div className={sidebarProp}>
      {/* Sidebar component, swap this element with another sidebar if you like
       */}
      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4">
        <div className="flex h-16 shrink-0 items-center text-white font-bold text-[20px] ">
          {getUserAccess() === EnumUserAcces.DEV
            ? "Dashboard-v0.8"
            : "Dashboard"}
        </div>
        <nav className="flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul className="-mx-2 space-y-1">
                {props.array_menuItems.map((x) => [
                  MenuItemBlock(x, props.menuSelectionHandler),
                ])}
              </ul>
            </li>
          </ul>
        </nav>
        {/* {Settings()} */}
      </div>
    </div>
  );
}

function MenuItemBlock(item: MenuItem, handler: any) {
  function clickthis() {
    handler(item);
  }

  return (
    <li onClick={clickthis} key={item.id}>
      <a
        href={"#" + item.id}
        className="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-400 hover:bg-gray-800 hover:text-white"
      >
        <svg
          className="h-6 w-6 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
        </svg>
        {item.title}
      </a>
    </li>
  );
}

/*
function Settings() {
  return (
    <li className="mt-auto">
      <a
        href="#settings"
        className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-400 hover:bg-gray-800 hover:text-white"
      >
        <svg
          className="h-6 w-6 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        Settings
      </a>
    </li>
  );
}*/
